import styled from "styled-components";
import { TextInput } from "@streeteasy/design-system";
import {
  GRAY_LIGHT,
  NOTICE_LIGHT,
  NOTICE_LIGHTEST
} from "@streeteasy/design-system/colors";
import Toast from "@streeteasy/design-system/legacy/Toast";
import { visuallyHiddenCss } from "@streeteasy/design-system/style-utilities/visually-hidden";

import { largeScreen } from "src/shared/constants/screenSizes";

const SearchForm = styled.form`
  @media screen and (min-width: ${largeScreen + 1}px) {
    margin: 0;
    position: relative;
    width: 100%;
  }

  @media screen and (max-width: ${largeScreen}px) {
    position: relative;
    margin: 0 12px;
    width: calc(100% - 30px);
  }
`;

const SearchInput = styled(TextInput)`
  border-color: ${GRAY_LIGHT};
  border-radius: 14px;
  font-weight: 300;
  height: 30px;
  padding: 5px 40px 5px 18px;

  @media screen and (max-width: ${largeScreen}px) {
    border-radius: 20px;
    height: 40px;
  }
`;

const SearchLabel = styled.label`
  ${visuallyHiddenCss}
`;

const SearchButton = styled.button.attrs(() => ({
  className: "fa fa-search",
  type: "submit"
}))`
  cursor: pointer;
  font-size: 16px;
  height: 20px;
  padding: 0;
  position: absolute;
  right: 11px;
  top: 5px;
  width: 23px;

  @media screen and (max-width: ${largeScreen}px) {
    background-color: transparent;
    border: none;
  }

  background-color: transparent;
  border: 0;

  @media screen and (max-width: ${largeScreen}px) {
    right: 15px;
    top: 10px;
  }
`;

const SearchButtonLabel = styled.span`
  ${visuallyHiddenCss}
`;

const ValidationErrorToast = styled(Toast)`
  & [class^="styled__Container"] {
    background-color: ${NOTICE_LIGHTEST};
    border-color: ${NOTICE_LIGHT};
  }
`;

export {
  SearchForm,
  SearchInput,
  SearchLabel,
  SearchButton,
  SearchButtonLabel,
  ValidationErrorToast
};
